'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenuTrigger } from '@react-aria/menu';
import { useListState } from '@react-stately/list';
import { useMenuTriggerState } from '@react-stately/menu';
import { useRef, useMemo } from 'react';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { SwanListboxButtonContext } from './listbox-button.context.js';
import { useListboxList, SwanListboxListContext } from './listbox-list.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { SwanPopoverContextProvider, useSwanPopover } from '../popover/popover.context.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
function SwanListboxContextProviderInner(o) {
    let { children: c, disabled: s, skin: f, selectionProps: _ } = o, { triggerRef: m, triggerProps: y, overlayState: j } = useSwanPopover(), { menuTriggerProps: O, menuProps: d } = useMenuTrigger(_object_spread_props(_object_spread({}, y), {
        isDisabled: s,
        type: 'listbox'
    }), j, m), g = useMemo(()=>({
            skin: f,
            triggerProps: O,
            triggerDisabled: null != s && s
        }), [
        O,
        s,
        f
    ]), { childItems: P, items: w, disabledKeys: h } = useCollectionContext(), v = useMemo(()=>{
        let e = null != _ ? _ : {}, { onSelectionChange: t } = e, r = _object_without_properties(e, [
            "onSelectionChange"
        ]);
        return _object_spread_props(_object_spread({}, d, r), {
            disabledKeys: h,
            onSelectionChange: (e)=>{
                null != t && t(e), 'multiple' !== r.selectionMode && j.close();
            }
        });
    }, [
        h,
        d,
        j,
        _
    ]), x = useRef(null), S = useListState(_object_spread_props(_object_spread({}, v), {
        items: w,
        children: P
    })), D = useListboxList(v, x, S);
    return jsx(SwanListboxButtonContext.Provider, {
        value: g,
        children: jsx(SwanListboxListContext.Provider, {
            value: D,
            children: c
        })
    });
}
function SwanListboxContextProvider(t) {
    let r = useMenuTriggerState({}), l = useRef(null), p = useRef(null), u = useModeExtractor(p, r.isOpen);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                popoverRef: l,
                triggerRef: p,
                overlayState: r,
                overlayProps: {},
                triggerProps: {},
                fullWidth: t.fullWidth,
                modes: u
            }), [
            l,
            p,
            r,
            t.fullWidth,
            u
        ]),
        children: jsx(SwanListboxContextProviderInner, _object_spread({}, t))
    });
}

export { SwanListboxContextProvider };
